import React, { useState, useEffect } from 'react';

const StagingGate = ({ children }) => {
  const [hasAccess, setHasAccess] = useState(false);
  const [isStaging, setIsStaging] = useState(false);
  const [password, setPassword] = useState('');

  useEffect(() => {
    const hostname = window.location.hostname;
    const isFirebaseApp = hostname.includes('.web.app') || hostname.includes('.firebaseapp.com');
    
    if (isFirebaseApp) {
      setIsStaging(true);
      
      // Check if already authenticated this session
      const stagingAuth = sessionStorage.getItem('staging-authenticated');
      if (stagingAuth === 'true') {
        setHasAccess(true);
      }
    } else {
      // Production domain - grant access immediately
      setHasAccess(true);
    }
  }, []);

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    
    // Simple password check (change this!)
    const validPasswords = ['gigify-staging-2024', 'dev-access', 'internal-only'];
    
    if (validPasswords.includes(password.toLowerCase())) {
      sessionStorage.setItem('staging-authenticated', 'true');
      setHasAccess(true);
    } else {
      alert('Invalid access code. Contact the development team.');
    }
  };

  const redirectToProduction = () => {
    window.location.href = 'https://gigify.co.za';
  };

  // If not staging, render children normally
  if (!isStaging) {
    return children;
  }

  // If staging but no access, show gate
  if (!hasAccess) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #002244 0%, #144874 100%)',
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Montserrat, sans-serif'
      }}>
        <div style={{
          background: 'rgba(255,255,255,0.1)',
          padding: '3rem',
          borderRadius: '15px',
          textAlign: 'center',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
          maxWidth: '500px',
          width: '90%'
        }}>
          <h1 style={{
            color: '#01a2f1',
            fontSize: '2.5rem',
            marginBottom: '1rem',
            fontWeight: 'bold'
          }}>
            GIGiFY
          </h1>
          
          <h2 style={{ marginBottom: '1rem' }}>🚧 Staging Environment</h2>
          
          <div style={{
            background: 'rgba(248, 80, 8, 0.2)',
            border: '1px solid #f85008',
            padding: '1.5rem',
            borderRadius: '10px',
            marginBottom: '2rem'
          }}>
            <strong>⚠️ Internal Access Only</strong><br/>
            <p>This is a development/testing environment.</p>
            <p>For the live application, visit:</p>
            <button
              onClick={redirectToProduction}
              style={{
                background: '#01a2f1',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '25px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '1rem',
                marginTop: '10px'
              }}
            >
              Go to gigify.co.za
            </button>
          </div>

          <form onSubmit={handlePasswordSubmit}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Development Access Code"
              style={{
                padding: '12px',
                border: '2px solid transparent',
                borderRadius: '5px',
                width: '250px',
                marginBottom: '15px',
                fontSize: '1rem',
                color: '#144874',
                backgroundColor: '#ffffff',
                outline: 'none',
                transition: 'all 0.3s ease'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#01a2f1';
                e.target.style.boxShadow = '0 0 0 3px rgba(1, 162, 241, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'transparent';
                e.target.style.boxShadow = 'none';
              }}
            />
            <br/>
            <button
              type="submit"
              style={{
                background: '#144874',
                color: 'white',
                border: 'none',
                padding: '12px 30px',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '1rem'
              }}
            >
              Access Staging
            </button>
          </form>
          
          <p style={{ 
            marginTop: '2rem', 
            fontSize: '0.9rem', 
            color: '#ccc' 
          }}>
            Need access? Contact the development team.
          </p>
        </div>
      </div>
    );
  }

  // Has access - render the app
  return children;
};

export default StagingGate;